// TEMPORARY site imagery. Replace files in /public/media/temp/site (same names) or edit paths here.
const variants = (name) => ({
  thumb: `/media/temp/site/${name}-thumb.webp`,
  medium: `/media/temp/site/${name}-medium.webp`,
  large: `/media/temp/site/${name}-large.webp`,
});

export const SITE_IMAGERY = {
  hero: { variants: variants("hero"), alt: "Black luxury SUV in a dark architectural space", width: 1264, height: 848 },
  sourcing: { variants: variants("sourcing"), alt: "Hand inspecting the paint finish of a black car", width: 1264, height: 848 },
  export: { variants: variants("export"), alt: "Vehicle export terminal at a Japanese port", width: 1264, height: 848 },
  company: { variants: variants("company"), alt: "Leather seat and steering wheel detail", width: 1264, height: 848 },
};

export const PAGE_IMAGERY = {
  inventory: SITE_IMAGERY.hero,
  sourcing: SITE_IMAGERY.sourcing,
  sell: SITE_IMAGERY.company,
  export: SITE_IMAGERY.export,
  contact: SITE_IMAGERY.company,
  privacy: SITE_IMAGERY.hero,
  legal: SITE_IMAGERY.hero,
};
